import React from 'react'
import { Badge, Card } from 'react-bootstrap'

const TicketListCom = ({ ticket, handleClickOnTicketRow, screenWidth, flag }) => {
    return (
        <>
            <Card className='ticket-card mt-2'>
                <Card.Body className={`p-0 ${ticket.length === 0 && 'd-flex justify-content-center align-items-center'}`}>
                    {ticket.length !== 0 ?
                        <div>
                            {ticket.map((item, id) => (
                                <div
                                    key={id}
                                    className={`w-100 d-flex border-bottom py-2 px-3 ticketRow align-items-center ${item.READ_STATUS === "N" ? "ticket-unread" : ""}`}
                                    onClick={() => handleClickOnTicketRow(item)}
                                    title={item.SUBJECT}
                                >
                                    <div>
                                        {item.PRIORITY === 'H' && <div style={{ width: 40, height: 40, borderRadius: "100%" }} className='d-flex justify-content-center align-items-center badge bg-danger me-2'>HI</div>}
                                        {item.PRIORITY === 'N' && <div style={{ width: 40, height: 40, borderRadius: "100%" }} className='d-flex justify-content-center align-items-center badge bg-warning me-2'>NM</div>}
                                        {item.PRIORITY === 'L' && <div style={{ width: 40, height: 40, borderRadius: "100%" }} className='d-flex justify-content-center align-items-center badge bg-success me-2'>LW</div>}
                                    </div>

                                    <div>
                                        <div className={`d-flex  ${screenWidth <= 600 ? "flex-column" : "align-items-center"}`}>
                                            <span className="text-slate-700 ms-1 text-sm">
                                                #{item.TICKET_ID}
                                            </span>
                                            <div
                                                className={`text-base mb-0 ms-2 text-slate-700 ticket-subject ${screenWidth <= 600 && "ticketSubJect"}`}
                                            >
                                                {item.SUBJECT}
                                            </div>
                                        </div>

                                        {screenWidth >= 600 &&
                                            <div className="d-flex align-items-center">
                                                <div className="border-end pe-2">
                                                    <div className="text-xs text-slate-500">Product</div>
                                                    <div className="text-xs">{item.PRODUCT_NM}</div>
                                                </div>
                                                <div className="border-end px-2">
                                                    <div className="text-xs text-slate-500">Last Activity</div>
                                                    <div className="text-xs">{item.LAST_ACTIVITY_DT}</div>
                                                </div>
                                                {/* <div className="border-end px-2">
                                                    <div className="text-xs text-slate-500">Replies</div>
                                                    <div className="text-xs">{item.ReplayCount} Reply</div>
                                                </div> */}
                                                <div className="px-2">
                                                    <div className="text-xs text-slate-500">Create Date</div>
                                                    <div className="text-xs">{item.CREATE_DT}</div>
                                                </div>
                                            </div>
                                        }
                                    </div>

                                    <div className={`ms-auto  d-flex gap-2 align-items-center`}>
                                        <div>
                                            {item.STATUS_CD === 'O' && <Badge bg="success">Open</Badge>}
                                            {item.STATUS_CD === 'C' && <Badge bg="secondary">Closed</Badge>}
                                            {item.STATUS_CD === 'P' && <Badge bg="primary">Pending</Badge>}
                                            {item.STATUS_CD === 'I' && <Badge bg="warning">In-Process</Badge>}
                                            {item.STATUS_CD === 'R' && <Badge bg="success">Re-Open</Badge>}
                                            {item.STATUS_CD === 'A' && <Badge bg="info">Assigned</Badge>}
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </div>
                        :
                        <div>
                            <img src="/assets/images/No-data.jpg" alt="No Data Found" style={{ width: 200 }} />
                            <h1 className="text-base text-center">No {flag === "I" ? "inquiry" : "ticket"} found</h1>
                        </div>
                    }
                </Card.Body>
            </Card >
        </>
    )
}

export default TicketListCom